var render = function render(){
  var _vm$voucherToDelete;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "voucher"
  }, [_c('div', {
    staticClass: "flex gap-5 justify-between items-end mb-6 mdmax:flex-col"
  }, [_c('div', {
    staticClass: "flex w-full gap-5 mdmax:w-full mdmax:flex-col"
  }, [_c('div', {
    staticClass: "w-full max-w-lg mdmax:w-full"
  }, [_c('label', {
    staticClass: "text-base text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Pencarian")]), _c('div', {
    staticClass: "relative"
  }, [_c('TextField', {
    attrs: {
      "type": "text",
      "withIcon": true,
      "placeholder": "Cari voucher..."
    },
    on: {
      "enter": _vm.onSearch
    },
    model: {
      value: _vm.search,
      callback: function ($$v) {
        _vm.search = $$v;
      },
      expression: "search"
    }
  }), _c('div', {
    staticClass: "absolute left-3 top-1/2 transform -translate-y-1/2"
  }, [_c('Search')], 1)], 1)])]), _c('div', {
    staticClass: "mdmax:w-full"
  }, [_c('button', {
    staticClass: "px-4 py-2 min-w-[140px] bg-primary-500 text-white rounded-lg font-medium hover:bg-primary-600 transition-colors whitespace-nowrap",
    on: {
      "click": function ($event) {
        return _vm.$router.push('/voucher/create');
      }
    }
  }, [_vm._v(" + Add Voucher ")])])]), _c('div', {
    staticClass: "bg-white rounded-lg shadow-sm overflow-hidden"
  }, [_c('div', {
    staticClass: "overflow-x-auto"
  }, [_c('table', {
    staticClass: "w-full text-left border-collapse"
  }, [_vm._m(0), _c('tbody', {
    staticClass: "text-sm text-neutral-700"
  }, [_vm._l(_vm.paginatedItems, function (voucher) {
    return _c('tr', {
      key: voucher.id,
      staticClass: "border-b hover:bg-neutral-50"
    }, [_c('td', {
      staticClass: "p-4 font-medium"
    }, [_vm._v(_vm._s(voucher.name))]), _c('td', {
      staticClass: "p-4"
    }, [_vm._v(_vm._s(voucher.voucher_code))]), _c('td', {
      staticClass: "p-4"
    }, [_vm._v(" " + _vm._s(_vm.formatDate(voucher.start_date)) + " - " + _vm._s(_vm.formatDate(voucher.end_date)) + " ")]), _c('td', {
      staticClass: "p-4"
    }, [_vm._v(_vm._s(voucher.discount_percentage) + "%")]), _c('td', {
      staticClass: "p-4"
    }, [_vm._v(" " + _vm._s(voucher.available_quota) + " / " + _vm._s(voucher.quota) + " ")]), _c('td', {
      staticClass: "p-4"
    }, [_c('span', {
      staticClass: "px-2 py-1 rounded text-xs font-medium",
      class: _vm.statusClass(voucher.status)
    }, [_vm._v(" " + _vm._s(voucher.status) + " ")])]), _c('td', {
      staticClass: "p-4"
    }, [_c('div', {
      staticClass: "flex gap-3"
    }, [_c('button', {
      staticClass: "text-neutral-500 hover:text-primary-500",
      on: {
        "click": function ($event) {
          return _vm.goToEdit(voucher.id);
        }
      }
    }, [_c('Pencil', {
      attrs: {
        "width": "18",
        "height": "18"
      }
    })], 1), _c('button', {
      staticClass: "text-neutral-500 hover:text-red-500",
      on: {
        "click": function ($event) {
          return _vm.openDeleteModal(voucher);
        }
      }
    }, [_c('Trash', {
      attrs: {
        "width": "18",
        "height": "18"
      }
    })], 1)])])]);
  }), _vm.paginatedItems.length === 0 ? _c('tr', [_c('td', {
    staticClass: "p-4 text-center text-neutral-500",
    attrs: {
      "colspan": "7"
    }
  }, [_vm._v(" Data tidak ditemukan ")])]) : _vm._e()], 2)])])]), _vm.filteredItems.length ? _c('div', {
    staticClass: "text-sm text-neutral-500 mt-2"
  }, [_vm._v(" Menampilkan " + _vm._s(_vm.startItem) + " - " + _vm._s(_vm.endItem) + " dari " + _vm._s(_vm.filteredItems.length) + " ")]) : _vm._e(), _vm.filteredItems.length ? _c('div', {
    staticClass: "mt-8 flex justify-end"
  }, [_c('Pagination', {
    attrs: {
      "currentPage": _vm.page,
      "totalCount": _vm.filteredItems.length,
      "pageSize": _vm.limit
    },
    on: {
      "onPageChange": _vm.changePage
    }
  })], 1) : _vm._e(), _c('Modal', {
    attrs: {
      "modalVisible": _vm.deleteModalVisible,
      "width": "400px"
    },
    on: {
      "close": _vm.closeDeleteModal
    }
  }, [_c('div', {
    staticClass: "text-center",
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('h3', {
    staticClass: "text-lg font-bold text-neutral-800 mb-2"
  }, [_vm._v("Hapus Voucher")]), _c('p', {
    staticClass: "text-neutral-600 mb-6"
  }, [_vm._v(" Apakah Anda yakin ingin menghapus voucher "), _c('strong', [_vm._v(_vm._s((_vm$voucherToDelete = _vm.voucherToDelete) === null || _vm$voucherToDelete === void 0 ? void 0 : _vm$voucherToDelete.name))]), _vm._v("? ")]), _c('div', {
    staticClass: "flex justify-center gap-3"
  }, [_c('button', {
    staticClass: "px-4 py-2 rounded-lg border border-neutral-300 text-neutral-600 hover:bg-neutral-50 font-medium",
    on: {
      "click": _vm.closeDeleteModal
    }
  }, [_vm._v(" Batal ")]), _c('button', {
    staticClass: "px-4 py-2 rounded-lg bg-red-500 text-white hover:bg-red-600 font-medium",
    on: {
      "click": _vm.confirmDelete
    }
  }, [_vm._v(" Hapus ")])])])])], 1);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('thead', [_c('tr', {
    staticClass: "bg-neutral-50 text-neutral-500 text-sm font-semibold border-b"
  }, [_c('th', {
    staticClass: "p-4"
  }, [_vm._v("Nama Voucher")]), _c('th', {
    staticClass: "p-4"
  }, [_vm._v("Kode")]), _c('th', {
    staticClass: "p-4"
  }, [_vm._v("Periode")]), _c('th', {
    staticClass: "p-4"
  }, [_vm._v("Diskon")]), _c('th', {
    staticClass: "p-4"
  }, [_vm._v("Kuota")]), _c('th', {
    staticClass: "p-4"
  }, [_vm._v("Status")]), _c('th', {
    staticClass: "p-4"
  }, [_vm._v("Action")])])]);

}]

export { render, staticRenderFns }